<div class="container-fluid py-3 py-lg-4 py-xl-5">
  <app-crud-form-header
    [id]="dataId()"
    title="estado"
    [disable]="readonly"
  ></app-crud-form-header>

  <form
    [formGroup]="data"
    (submit)="submit()"
    class="row justify-content-around gy-3 gy-lg-4"
  >
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="name" required />

        @if (data.get('name')?.touched &&
        data.get('name')?.hasError('required')) {
        <mat-error> El Nombre es <strong>requerido</strong> </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-12">
      <ng-select
        id="country"
        appearance="outline"
        [items]="countries"
        bindLabel="name"
        bindValue="id"
        formControlName="country_id"
        placeholder="País"
        [clearable]="false"
      ></ng-select>

      @if (data.get('country_id')?.touched &&
      data.get('country_id')?.hasError('required')) {
      <div id="countryValidation" class="invalid-feedback">
        El país es <strong>requerido</strong>
      </div>
      }
    </div>

    <app-alert [content]="alertData"></app-alert>

    <div class="w-100 mt-0"></div>

    <div class="col-12 px-0">
      <app-crud-form-footer
        [id]="dataId()"
        [created]="created"
        [disable]="readonly"
        [loading]="loadingService.getLoading()"
        (cancel)="cancel()"
      ></app-crud-form-footer>
    </div>
  </form>
</div>
